export const STORAGE_AUTH_TOKEN = "authToken";
